import { render, staticRenderFns } from "./guoneinew.vue?vue&type=template&id=018d0d70&scoped=true&"
import script from "./guoneinew.vue?vue&type=script&lang=js&"
export * from "./guoneinew.vue?vue&type=script&lang=js&"
import style0 from "./guoneinew.vue?vue&type=style&index=0&id=018d0d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018d0d70",
  null
  
)

export default component.exports